export const portalPlacement: "auto" | "bottom" | "top" = "auto";